export const scopeCredential = {

        dashboard: {
            read:        ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTERN_USER', 'AGENT'],
            edit:        ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTERN_USER',],
            lastsheet:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER'],
            lastevent:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER'],
        },
        planning: {
            read:        ['ADMIN_USER', 'SUPER_USER', ],
            edit:        ['ADMIN_USER', 'SUPER_USER', ],
            lastsheet:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER'],
            lastevent:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER'],
        },
        event     : {},
        eventedit : {
            read:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTERN_USER'],
            edit:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER'],
            delete: ['ADMIN_USER', 'SUPER_USER']
        },
        map : {},
        document : {
            read:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTERN_USER', 'AGENT'],
            edit:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER'],
            delete: ['ADMIN_USER', 'SUPER_USER', 'INTER_USER']
        },
        report : {},
        reportext : {},
        // Params
        users: {
            read: ['ADMIN_USER', 'SUPER_USER', 'INTER_USER']
        },
        useredit: {
            read: ['ADMIN_USER', 'SUPER_USER', 'INTER_USER'],
            edit: ['ADMIN_USER', 'SUPER_USER', 'INTER_USER']
        },
        phyto : {
            read:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTERN_USER', 'AGENT'],
            edit:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER'],
            delete: ['ADMIN_USER', 'SUPER_USER', 'INTER_USER']
        },
        states: {},
        stateedit: {
            read: ['ADMIN_USER', 'SUPER_USER'],
            edit: ['ADMIN_USER', 'SUPER_USER']
        },
        types: {},
        typeedit: {
            read: ['ADMIN_USER', 'SUPER_USER'],
            edit: ['ADMIN_USER', 'SUPER_USER']
        },
        contacts: {
            read:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTERN_USER'],
            edit:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER'],
            delete: ['ADMIN_USER', 'SUPER_USER', 'INTER_USER']
        },
        contacts_view: {
            read:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER', 'EXTERN_USER'],
            edit:   ['ADMIN_USER', 'SUPER_USER', 'INTER_USER'],
            delete: ['ADMIN_USER', 'SUPER_USER', 'INTER_USER']
        },
        jobs     : {
            read:   ['ADMIN_USER', 'SUPER_USER' ],
            edit:   ['ADMIN_USER', 'SUPER_USER' ],
            delete: ['ADMIN_USER', 'SUPER_USER' ]
        },
}